<template>
  <div>
    <div :style="styles.container(chartsReady)">
      <!-- <div
        :style="styles.hiddenMenuToggle(this.showHiddenMenu)"
      >
        <ul
            :style="styles.rangeDropdown(this.showHiddenMenu)"
          >
            <li
              key="hidden-line-1"
              :style="styles.rangeItem"
            >
              Manage Assets
              &nbsp;&nbsp;
              <i className="material-icons" :style="styles.exitIcon">exit_to_app</i>
            </li>
          </ul>
      </div> -->
      <div :style="styles.dashboardContainer">
          <select
            @change="changeCharts"
            :value="ranges[currentRange].key"
            ref="rangeDropdown"
            :style="styles.analyticsDropdown"
          >
            <option
              v-for="(range, index) in ranges"
              :value="range.key"
              :key="range.key"
            >
              {{range.label}}
            </option>
          </select>
      </div>
      <div :style="styles.dataCardSection">
        <div class="dataCardWrap" :style="styles.dataCardWrap('login')">
          <h5 :style="styles.cardTitle">Logins ({{ printTotal('logins') }})</h5>
          <canvas
            ref="loginChart"
            width="auto"
            height="200"
            :style="styles.chartCanvas(chartsReady)"
          ></canvas>
          <Spinner v-if="!chartsReady" />

        </div>
        <div class="dataCardWrap" :style="styles.dataCardWrap('contact')">
          <h5 :style="styles.cardTitle">Contacts Added ({{ printTotal('contacts') }})</h5>
          <canvas
            id="contactChart"
            width="auto"
            height="200"
            :style="styles.chartCanvas(chartsReady)"
          ></canvas>
          <Spinner v-if="!chartsReady" />

        </div>

        <div class="dataCardWrap" :style="styles.dataCardWrap('meeting')">
          <h5 :style="styles.cardTitle">Experiences Scheduled ({{ printTotal('meetings') }})</h5>
          <canvas
            id="meetingChart"
            width="auto"
            height="200"
            :style="styles.chartCanvas(chartsReady)"
          ></canvas>
          <Spinner v-if="!chartsReady" />
        </div>

        <div class="dataCardWrap" :style="styles.dataCardWrap('cart')">
          <h5 :style="styles.cardTitle">Shopping Carts ({{ printTotal('share_cart') }})</h5>
          <canvas
            id="cartChart"
            width="auto"
            height="200"
            :style="styles.chartCanvas(chartsReady)"
          ></canvas>
          <Spinner v-if="!chartsReady" />
        </div>

        <div class="dataCardWrap" :style="styles.dataCardWrap('media')">
          <h5 :style="styles.cardTitle">Media Viewed ({{ printTotal('media_started') }} started, {{ printTotal('media_finished') }} finished, {{ printTotal('media_shared') }} shared)</h5>
          <canvas
            id="mediaChart"
            width="auto"
            height="200"
            :style="styles.chartCanvas(chartsReady)"
          ></canvas>
          <Spinner v-if="!chartsReady" />
        </div>

        <div class="dataCardWrap" :style="styles.dataCardWrap('enrollment')">
          <h5 :style="styles.cardTitle">Enrollment ({{ printTotal('share_enrollment') }} shared, {{ printTotal('complete_enrollment') }} completed)</h5>
          <canvas
            id="enrollmentChart"
            width="auto"
            height="200"
            :style="styles.chartCanvas(chartsReady)"
          ></canvas>
          <Spinner v-if="!chartsReady" />
        </div>

      </div>
    </div>
    <div
      v-if="!chartsReady"
    >
      <Spinner
      />
      <p :style="styles.loadingLabel">
        Generating report...
      </p>
    </div>
  </div>
</template>

<script>
import store from '../../store';
import moment from 'moment';
import { getResource } from '../../services/Utils';
import Spinner from '../general/Spinner';
import Chart from 'chart.js';
export default {
  name: 'dashboard',
  components: {
    Spinner
  },
  data() {
    return {
      icon: store.getters.getTenant.icon,
      chartsReady: false,
      showHiddenMenu: false,
      currentRange: 'week',
      ranges: {
        day: {
          label: 'Last 24 Hours',
          key: 'day',
          start: () =>
            moment()
              .add(-2, 'days')
              .unix(),
          end: () => moment().unix(),
          unit: 1,
          labels: () => [
            moment()
              .add(-1, 'days')
              .format('dddd'),
            'Today'
          ]
        },
        week: {
          label: 'Last 7 Days',
          key: 'week',
          start: () =>
            moment()
              .add(-1, 'weeks')
              .unix(),
          end: () => moment().unix(),
          unit: 1,
          labels: () => [
            moment()
              .add(-6, 'days')
              .format('dddd'),
            moment()
              .add(-5, 'days')
              .format('dddd'),
            moment()
              .add(-4, 'days')
              .format('dddd'),
            moment()
              .add(-3, 'days')
              .format('dddd'),
            moment()
              .add(-2, 'days')
              .format('dddd'),
            moment()
              .add(-1, 'days')
              .format('dddd'),
            'Today'
          ]
        },
        month: {
          label: 'Last 30 Days',
          key: 'month',
          start: () =>
            moment()
              .add(-30, 'days')
              .unix(),
          end: () => moment().unix(),
          unit: 1,
          labels: () =>
            new Array(30).map((item, i) =>
              moment()
                .add(i * -1, 'days')
                .format('M/D')
            )
        },
        threeMonth: {
          label: 'Last 90 Days',
          key: 'threeMonth',
          start: () =>
            moment()
              .add(-90, 'days')
              .unix(),
          end: () => moment().unix(),
          unit: 1,
          labels: () =>
            new Array(90).map((item, i) =>
              moment()
                .add(i * -1, 'days')
                .format('M/D')
            )
        },
        year: {
          label: 'Last 365 Days',
          key: 'year',
          start: () =>
            moment()
              .add(-365, 'days')
              .unix(),
          end: () => moment().unix(),
          unit: 1,
          labels: () =>
            new Array(365).map(i =>
              moment()
                .add(i * -1, 'days')
                .format('M/D')
            )
        }
      },
      charts: store.getters.getCharts,
      styles: {
        container: (r) => ({
          background: '#F5F5F5',
          minHeight: '100vh',
          opacity: r ? '1' : '0',
        }),
        dataCardSection: {
          display: 'flex',
          flexFlow: 'row wrap',
          padding: '0 10px'
        },
        dataCardWrap: type => ({
          border: '1px solid #eee',
          background: '#fff',
          boxShadow: '0 2px 5px 1px rgba(0,0,0,0.08)',
          minHeight: '200px',
          display: 'flex',
          justifyContent: 'center',
          padding: '10px',
          flexFlow: 'column nowrap',
          position: 'relative',
          alignItems: 'center',
          margin: type === 'media' ? '10px 10px 60px' : '10px',
          borderRadius: '5px'
        }),
        cardTitle: {
          margin: '10px auto',
          color: '#333',
          textTransform: 'uppercase',
          display: 'flex',
          alignItems: 'center'
        },
        loadingLabel: {
          position: 'absolute',
          bottom: '40px',
          fontSize: '1.1em',
          color: '#aaa',
          fontWeight: '700',
          textAlign: 'center',
          left: '0',
          right: '0',
        },
        hiddenMenuToggle: showHiddenMenu => ({
          background: 'rgba(0,0,0,0.25)',
          opacity: showHiddenMenu ? 1 : 0,
          pointerEvents: showHiddenMenu ? 'auto' : 'none',
          position: 'fixed',
          transition: '100ms ease-out',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: '100vh',
          width: '100vw',
          zIndex: 98
        }),
        rangeDropdown: showHiddenMenu => ({
          position: 'fixed',
          top: 110,
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#fff',
          boxShadow: '0 2px 5px 1px rgba(0,0,0,0.1)',
          width: 200,
          border: '1px solid #ddd',
          listStyle: 'none',
          padding: 0,
          margin: 0,
          zIndex: 99,
          opacity: showHiddenMenu ? 1 : 0,
          pointerEvents: showHiddenMenu ? 'auto' : 'none'
        }),
        rangeItem: {
          padding: 15,
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          borderBottom: '1px solid #ddd',
          ':hover': {
            background: '#f5f5f5',
            cursor: 'pointer'
          }
        },
        exitIcon: {
          margin: 'auto 0 auto auto',
          fontSize: '1.25em'
        },
        dashboardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: 'transparent',
          height: 'auto',
          padding: '20px 10px 10px 10px',
          position: 'relative'
        },
        logo: {
          height: '80px',
          width: '80px',
          margin: 'auto auto 20px'
        },
        analyticsDropdown: {
          fontSize: '1.25em',
          fontWeight: 700,
          width: '250px',
          margin: 'auto auto auto 0',
          textAlign: 'center',
          outline: '0',
          padding: '10px 20px'
        },
        loadingIconContainer: {
          width: '100%',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        chartCanvas: showChart => ({
          transition: 'all 0.2s',
          opacity: showChart ? '1' : '0'
        })
      }
    };
  },
  mounted() {
    this.getChartAnalytics();
  },
  methods: {
    async changeCharts() {
      this.chartsReady = false;
      this.currentRange = this.$refs.rangeDropdown.value;
      const charts = await this.getChartAnalytics(this.currentRange);
      this.chartsReady = true;
    },
    getChartAnalytics() {
      // we would put our Utils.getResources() call here, then work with the result. for now we have some hard-coded data

      return getResource(
        '/v1/analytics/daily',
        `start=${this.ranges[this.currentRange].start()}&end=${this.ranges[
          this.currentRange
        ].end()}&unit=${this.ranges[this.currentRange].unit}`
      )
        .then(chartData => {
          // start preparing the data for charts
          const logins = Object.keys(chartData.login).map(neg => {
            return chartData.login[neg];
          });
          const contacts = Object.keys(chartData.add_contact).map(neg => {
            return chartData.add_contact[neg];
          });
          const meetings = Object.keys(chartData.add_meeting).map(neg => {
            return chartData.add_meeting[neg];
          });
          const sc = Object.keys(chartData.share_cart).map(neg => {
            return chartData.share_cart[neg];
          });
          const ms = Object.keys(chartData.media_started).map(neg => {
            return chartData.media_started[neg];
          });
          const mf = Object.keys(chartData.media_finished).map(neg => {
            return chartData.media_finished[neg];
          });
          const msh = Object.keys(chartData.media_shared).map(neg => {
            return chartData.media_shared[neg];
          });

          const ensh = Object.keys(chartData.share_enrollment).map(neg => {
            return chartData.share_enrollment[neg];
          });
          const enc = Object.keys(chartData.complete_enrollment).map(neg => {
            return chartData.complete_enrollment[neg];
          });

        //   console.log(ensh);
        //   console.log(enc);

          const uc = {
            logins: logins.reverse(),
            contacts: contacts.reverse(),
            meetings: meetings.reverse(),
            share_cart: sc.reverse(),
            media_started: ms.reverse(),
            media_finished: mf.reverse(),
            media_shared: msh.reverse(),
            share_enrollment: ensh.reverse(),
            complete_enrollment: enc.reverse(),
          };

          // commit the results to store
          this.$store.commit('setCharts', uc);
          this.chartsReady = true;
          return;
        })
        .then(() => this.setupCharts())
        .catch(error => console.log(error));
    },

    setupCharts() {
      this.setupCartChart();
      this.setupMediaChart();
      this.setupLoginChart();
      this.setupContactChart();
      this.setupMeetingChart();
      this.setupEnrollmentChart();
    },

    setupEnrollmentChart() {
      console.log('setting up enrollment chart')
      const ctx = 'enrollmentChart';
      const yMax = Math.max.apply(null, store.getters.getCharts.share_enrollment, store.getters.getCharts.complete_enrollment) * 2;
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [
            {
              label: 'Shared',
              data: store.getters.getCharts.share_enrollment,
              borderColor: ['#09a3ed'],
              backgroundColor: ['transparent'],
            },
            {
              label: 'Completed',
              data: store.getters.getCharts.complete_enrollment,
              borderColor: ['green'],
              backgroundColor: ['transparent']
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  max: yMax,
                  beginAtZero: true,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }
            ]
          }
        }
      });
    },

    setupLoginChart() {
      const ctx = this.$refs.loginChart;
      const yMax = Math.max.apply(null, store.getters.getCharts.logins) * 2;
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [
            {
              label: 'Logins',
              data: store.getters.getCharts.logins,
              borderColor: ['#09a3ed'],
              backgroundColor: ['transparent'],
              borderWidth: 0
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  max: yMax,
                  beginAtZero: true,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }
            ]
          }
        }
      });
    },

    setupMeetingChart() {
    //   console.log(this.ranges[this.currentRange].labels());
      const ctx = 'meetingChart';
      const yMax = Math.max.apply(null, store.getters.getCharts.meetings) * 2;
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [
            {
              label: 'Experiences Scheduled',
              data: store.getters.getCharts.meetings,
              borderColor: ['purple'],
              backgroundColor: ['transparent'],
              borderWidth: 0
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: yMax,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }
            ]
          }
        }
      });
    },

    setupContactChart() {
      const ctx = 'contactChart';
      const yMax = Math.max.apply(null, store.getters.getCharts.contacts) * 1.2;
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [
            {
              label: 'Contacts Added',
              data: store.getters.getCharts.contacts,
              borderColor: ['navy'],
              backgroundColor: ['transparent'],
              borderWidth: 0
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: yMax,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }
            ]
          }
        }
      });
    },

    setupCartChart() {
      const ctx = 'cartChart';
      const yMax =
        Math.max.apply(null, store.getters.getCharts.share_cart) * 1.2;
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [
            {
              label: 'Shared',
              data: store.getters.getCharts.share_cart,
              borderColor: ['green'],
              backgroundColor: ['transparent'],
              borderWidth: 0
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: yMax,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }
            ]
          }
        }
      });
    },

    setupMediaChart() {
      const ctx = 'mediaChart';
      const yMax =
        Math.max.apply(null, store.getters.getCharts.media_shared) * 1.2;
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.ranges[this.currentRange].labels(),
          datasets: [
            {
              label: 'Finished',
              data: store.getters.getCharts.media_finished,
              borderColor: ['red'],
              backgroundColor: ['transparent']
            },
            {
              label: 'Started',
              data: store.getters.getCharts.media_started,
              borderColor: ['orange'],
              backgroundColor: ['transparent']
            },
            {
              label: 'Shared',
              data: store.getters.getCharts.media_shared,
              borderColor: ['green'],
              backgroundColor: ['transparent']
            }
          ]
        },
        options: {
          legend: {
            display: true
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stacked: true,
                  max: yMax,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }
            ],
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stacked: true
                }
              }
            ]
          }
        }
      });
    },
    printTotal(stat) {
    //   console.log(store.getters.getCharts);
    //   console.log(stat);
      const arr = store.getters.getCharts[stat];
      let total = 0;
      arr.forEach((item, i) => {
        total += item;
      });
      return total;
    }
  }
};
</script>
<style lang="scss" scoped>
.dataCardWrap {
  width: calc(50% - 20px);

  @media all and (max-width: 1024px) {
    width: 100%;
  }
}
</style>
<style>
.chartjs-render-monitor {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue